import { render } from "./BorderRadius.vue?vue&type=template&id=390d2232&scoped=true&ts=true"
import script from "./BorderRadius.vue?vue&type=script&lang=ts"
export * from "./BorderRadius.vue?vue&type=script&lang=ts"

import "./BorderRadius.vue?vue&type=style&index=0&id=390d2232&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390d2232"]])

export default __exports__